/** Offline-authored sleeve clearance, driven by each arm's actual elevation. */
import * as THREE from 'three';
const root = new THREE.Vector3(), top = new THREE.Vector3(), arm = new THREE.Vector3(), elbow = new THREE.Vector3();
const boneMaps = new WeakMap<THREE.Skeleton, Map<string, THREE.Bone>>();
export function applyGarmentPose(mesh: THREE.SkinnedMesh): void {
  const dict = mesh.morphTargetDictionary, values = mesh.morphTargetInfluences;
  if (!dict || !values || dict.cloth_raise_l === undefined) return;
  let bones = boneMaps.get(mesh.skeleton);
  if (!bones) { bones = new Map(mesh.skeleton.bones.map(b => [b.name, b])); boneMaps.set(mesh.skeleton, bones); }
  const pelvis = bones.get('pelvis'), spine = bones.get('spine_05');
  if (!pelvis || !spine) return;
  root.setFromMatrixPosition(pelvis.matrixWorld); top.setFromMatrixPosition(spine.matrixWorld).sub(root).normalize();
  for (const side of ['l', 'r']) {
    const upper = bones.get('upperarm_' + side), lower = bones.get('lowerarm_' + side), index = dict['cloth_raise_' + side];
    if (!upper || !lower || index === undefined) continue;
    arm.setFromMatrixPosition(upper.matrixWorld); elbow.setFromMatrixPosition(lower.matrixWorld).sub(arm).normalize();
    const spread = dict['cloth_spread_' + side];
    if (spread !== undefined) {
      const dot = elbow.dot(top);
      const lift = THREE.MathUtils.smoothstep(dot, -.75, 0);
      const raise = THREE.MathUtils.smoothstep(dot, 0, .85);
      values[spread] = lift * (1 - raise);
      values[index] = raise;
      continue;
    }
    const t = THREE.MathUtils.clamp((elbow.dot(top) - .05) / .85, 0, 1);
    values[index] = t * t * (3 - 2 * t);
  }
}
